/**
 * @generated SignedSource<<60c6d69fa9b1ecacbde606804d296151>>
 * @relayHash ebe636f5db0fb9fad1c173e00da1f3eb
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ebe636f5db0fb9fad1c173e00da1f3eb

import { ConcreteRequest } from 'relay-runtime';
export type ShiftType = "BOOK_A_DOC_AT_PHARMACY" | "CARDIOLOGY" | "CHATS" | "DERMATOLOGY" | "GENERAL" | "GYNAECOLOGY" | "KIDS_LINE" | "MEDICAL_SUPERVISOR" | "SPORTS" | "UROLOGY" | "VACCINATION_PRESCRIPTION";
export type useAgentPlanningsQuery$variables = Record<PropertyKey, never>;
export type useAgentPlanningsQuery$data = {
  readonly doctors: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly shifts: ReadonlyArray<{
          readonly actualPerformance: number;
          readonly actualTime: number;
          readonly date: any;
          readonly shiftTypes: ReadonlyArray<ShiftType>;
          readonly slotId: number;
        }>;
        readonly userName: string;
      };
    }> | null;
  } | null;
};
export type useAgentPlanningsQuery = {
  response: useAgentPlanningsQuery$data;
  variables: useAgentPlanningsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DoctorsConnection",
    "kind": "LinkedField",
    "name": "doctors",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DoctorsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Doctor",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Shift",
                "kind": "LinkedField",
                "name": "shifts",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualPerformance",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shiftTypes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slotId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAgentPlanningsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useAgentPlanningsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "ebe636f5db0fb9fad1c173e00da1f3eb",
    "metadata": {},
    "name": "useAgentPlanningsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5e8ed31d6eb1c48114900b0694538fe3";

export default node;
